String.isNullOrEmpty = function (val: any): boolean {
  return (val === undefined || val === null || val.trim() === '');
};
Date.prototype.toUTC = function (): Date {
  return new Date(this.toUTCString().replace(' GMT', ''));
};
Date.prototype.addSeconds = function (seconds: number) {
  this.setSeconds(this.getSeconds() + seconds);
  return this;
};
Date.prototype.addMinutes = function (minutes: number) {
  this.setMinutes(this.getMinutes() + minutes);
  return this;
};
Date.prototype.addHours = function (hours: number) {
  this.setHours(this.getHours() + hours);
  return this;
};
Date.prototype.addDays = function (days: number) {
  this.setDate(this.getDate() + days);
  return this;
};
Date.prototype.addMonths = function (months: number) {
  this.setMonth(this.getMonth() + months);
  return this;
};
Date.prototype.addYears = function (years: number) {
  this.setFullYear(this.getFullYear() + years);
  return this;
};
